// extracted by mini-css-extract-plugin
module.exports = {"superInput":"Input_superInput__1sGR_","errorInput":"Input_errorInput__xHQfi","error":"Input_error__3Skfz"};